var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergiateollisuusViolettiRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 901.9 212.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #590a99;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.9 148.5 49.1 148.5 49.1 137.2 12.9 137.2 12.9 111.7 56.4 111.7 56.4 100.4 .7 100.4 .7 186.8 58 186.8 58 175.5 12.9 175.5 12.9 148.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.4,122.7c-10.2,0-16.3,4.1-19.8,8l-1.2-7.3h-10.1v63.4h11.6v-31.7c0-13.6,6.7-21.7,17.9-21.7s15.9,6.5,15.9,18.8v34.6h11.6v-35.2c0-25.2-16.2-28.9-25.8-28.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M161,122.7c-17.7,0-30.1,13.3-30.1,32.4s12.7,32.4,31.5,32.4,25.1-8.9,27.7-22.1l.2-1h-11.7l-.2.6c-1.9,7.5-8.2,12-16.8,12s-18.3-7.5-18.7-19.2h47.2s.8,0,.8,0v-.7c.2-1.4.3-2.9.3-4.3-.5-18.6-12-30.1-30.1-30.1ZM143.6,148c1.3-8.6,8.6-15,17.5-15s16.4,5.6,17.6,15h-35.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.7,131.3l-1.1-7.9h-10.1v63.4h11.6v-32.3c0-7.4,2-19.8,15.7-19.8h5.8v-11.3h-3.6c-10.3,0-15.2,3.9-18.2,7.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.4,132.5c-4.5-6.4-11.6-9.8-20.7-9.8-18,0-30.5,13.3-30.5,32.4s12,32.4,30.5,32.4,15.8-3.2,20.4-9.5v4.6c0,12.6-6.3,18.7-19.2,18.7s-16.5-4.2-18.1-11.5v-.6h-11.9v.9c1.7,13.6,12.6,21.7,29.3,21.7s31.5-9.7,31.5-28.8v-59.6h-10.1l-1.1,9.1ZM265.7,177.1c-11.8,0-19.7-8.8-19.7-22s7.9-22,19.7-22,19.5,8.9,19.5,22.2-8,21.7-19.5,21.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M314,100.1c-4.1,0-7.2,3.1-7.2,7.2s3.1,7.2,7.2,7.2,7.2-3.1,7.2-7.2-3.1-7.2-7.2-7.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 308.1,
    y: 123.4,
    width: 11.6,
    height: 63.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.4,172.8v-27c0-14.7-9.4-23.1-25.7-23.1s-25.5,7.5-27,20v.9c-.1,0,11.4,0,11.4,0v-.7c1.3-6,7-9.8,15.1-9.8s14.6,4.5,14.6,12v3.4h-17.4c-16.5,0-25.7,7.1-25.7,20.1s9.3,18.9,23.6,18.9,15.2-3,20.1-8.9c.8,5.6,4.6,8.2,11.8,8.2h6.3v-10.7h-4c-2.4,0-3.2-.5-3.2-3.3ZM353.2,177.4c-7.7,0-12.6-3.7-12.6-9.4s4.4-9.5,13-9.5h18.3v2.2c0,10.3-7.2,16.6-18.7,16.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M412.3,169.8v-35.7h16v-10.7h-16v-17.3h-11.6v17.3h-11.1v10.7h11.1v35.8c0,11.9,5.1,16.9,16.9,16.9h11.6v-10.7h-10.6c-4.8,0-6.3-1.5-6.3-6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M462.1,122.7c-17.7,0-30.1,13.3-30.1,32.4s12.6,32.4,31.5,32.4,25.1-8.9,27.7-22.1l.2-1h-11.7l-.2.6c-1.9,7.5-8.2,12-16.8,12s-18.3-7.5-18.7-19.2h47.9s0-.8,0-.8c.1-1.4.2-2.9.2-4.3-.5-18.6-12-30.1-30.1-30.1ZM444.7,148c1.3-8.6,8.6-15,17.5-15s16.4,5.6,17.6,15h-35.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M530.8,122.7c-18.5,0-31.5,13.3-31.5,32.4s12.9,32.4,31.5,32.4,31.5-13.3,31.5-32.4-12.9-32.4-31.5-32.4ZM530.8,177.1c-11.6,0-19.7-9-19.7-22s8.1-22,19.7-22,19.7,9,19.7,22-8.1,22-19.7,22Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 571.6,
    y: 100.4,
    width: 11.6,
    height: 86.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 594.6,
    y: 100.4,
    width: 11.6,
    height: 86.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 617.6,
    y: 123.4,
    width: 11.6,
    height: 63.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M623.5,100.1c-4.1,0-7.2,3.1-7.2,7.2s3.1,7.2,7.2,7.2,7.2-3.1,7.2-7.2-3.1-7.2-7.2-7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M665.7,149.2c-9.4-1.1-14.8-2.1-14.8-7.9s5.3-8.5,13.6-8.5,13.5,4.1,14.2,10.3v.7h11.9v-.9c-1-12.6-10.7-20.1-26.1-20.3-8.2-.1-15.3,2.4-19.9,6.9-3.4,3.3-5.2,7.6-5.2,12.4,0,13.8,12.6,16.6,25.6,18.1h.7c9.6,1.2,14.6,2.1,14.6,8.6s-5.8,8.6-14.1,8.6-15.9-4.6-16.3-11.8v-.8h-11.8v.8c.3,13.5,11,21.9,28.1,21.9s25.5-8,25.5-19.5-12.3-17.2-26-18.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M743.9,155.1c0,13.6-6.4,21.7-17.2,21.7s-15.3-6.5-15.3-18.8v-34.6h-11.6v35.2c0,25.2,15.8,28.9,25.2,28.9s14.5-2.7,19.2-7.9l1.2,7.2h10.1v-63.4h-11.6v31.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M810.2,155.1c0,13.6-6.4,21.7-17.2,21.7s-15.3-6.5-15.3-18.8v-34.6h-11.6v35.2c0,25.2,15.8,28.9,25.2,28.9s14.5-2.7,19.2-7.9l1.2,7.2h10.1v-63.4h-11.6v31.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M858.2,149.2c-9.4-1.1-14.8-2.1-14.8-7.9s5.3-8.5,13.6-8.5,13.5,4.1,14.2,10.3v.7h11.9v-.9c-1-12.6-10.7-20.1-26.1-20.3-8.2-.1-15.3,2.4-19.9,6.9-3.4,3.3-5.2,7.6-5.2,12.4,0,13.8,12.6,16.6,25.6,18.1h.7c9.6,1.2,14.6,2.1,14.6,8.6s-5.8,8.6-14.1,8.6-15.9-4.6-16.3-11.8v-.8h-11.8v.8c.3,13.5,11,21.9,28.1,21.9s25.5-8,25.5-19.5-12.3-17.2-26-18.9Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M800.9,36.4c4.6-13.8,24.2-20.7,45.2-16.6l-18.6,47.5h0c5.9,2.3,12.5-.6,14.8-6.5l19-48.6-5.9-1.7c-29.4-8.6-58,1.2-65.1,22.4-5.3,15.7,2.4,33.9,19.6,46.8h0c2.4-6.2,1.3-13.1-2.8-18.4-6.3-8.1-8.7-17.1-6-24.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M872.1,17.4c-2.2,5.7-.5,12.2,4.2,16.1,11,9,16.4,22.4,12.6,32.4-8.2,22-41.6,21.6-64.9,9.9l-3.9,10.1c25.1,13.7,68.1,13.9,79.6-16.4,6.7-17.7-5.5-41.2-27.6-52.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergiateollisuusViolettiRgb);
export default __webpack_public_path__ + "static/media/energiateollisuus_violetti_rgb.959b8c6aa7cd547d4226f4a9b8af3ae6.svg";
export { ForwardRef as ReactComponent };